/** Icones traits du parcours (critique impeccable du 13/10/2026 : plus de
 *  glyphes unicode en guise d'icones). Une seule famille : 16 px, trait 1,6. */
export const TRACES = {
  gauche: "M10 3.5 5.5 8l4.5 4.5",
  droite: "M6 3.5 10.5 8 6 12.5",
  coche: "M3.5 8.5l3 3 6-7",
  rond: "M8 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  bas: "M8 3v10m0 0-4-4m4 4 4-4",
  haut: "M8 13V3m0 0L4 7m4-4 4 4",
  // Lot 2bis (15/10/2026).
  horloge: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12ZM8 4.8V8l2.2 1.4",
  croix: "M4.5 4.5l7 7m0-7-7 7",
  cle: "M10 9.5a3.5 3.5 0 1 0-3.3-2.3L2.5 11.4V13.5h2.1v-1.4h1.4v-1.4h1.4l.9-.9A3.5 3.5 0 0 0 10 9.5Zm1-4.6h.01",
  envoi: "M13.5 2.5 7 9m6.5-6.5-4 11-2.5-4.5L2.5 6.5l11-4Z",
  // 20/10/2026 : « Continuer sur mon téléphone ».
  telephone: "M5.5 1.5h5a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1ZM7 12h2",
} as const;

export function Ico({ nom, taille = 16 }: { nom: keyof typeof TRACES; taille?: number }) {
  return (
    <svg className="ico" viewBox="0 0 16 16" width={taille} height={taille} aria-hidden="true" focusable="false">
      <path d={TRACES[nom]} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"
            strokeLinejoin="round" />
    </svg>
  );
}

/** Pied de carte : transmettre et refuser, discrets (lot 2bis : « Transmettre »
 *  et « Refuser de signer » en actions secondaires). Sans onTransmettre
 *  (transmission interdite, Franck 20/10/2026), le lien n'existe pas. */
export function ActionsDiscretes({ onTransmettre, transmettre, onDecline, refuser }: {
  onTransmettre?: () => void;
  transmettre: string;
  onDecline: () => void;
  refuser: string;
}) {
  return (
    <div className="actions-discretes">
      {onTransmettre && <button type="button" className="btn btn--discret" onClick={onTransmettre}>{transmettre}</button>}
      <button type="button" className="btn btn--refus" onClick={onDecline}>{refuser}</button>
    </div>
  );
}
